import { Box, Chip, CircularProgress, Divider, Paper } from "@mui/material";
import { useFetchJeopardySeverity } from "../hooks/useFetchJeopardySeverity";
import { Cancel } from "@mui/icons-material";

export const JeoSeverity = ({ selectedFilterCode, onSelectedFilter }: { selectedFilterCode: string | null, onSelectedFilter: (filterCode: string | null) => void }) => {

    const { data, isLoading, isError, error } = useFetchJeopardySeverity();

    if (isLoading) {
        return (
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
                py={2}
            >
                <CircularProgress size={20} />
            </Box>
        );
    };

    return (
        <Box display={'flex'} justifyContent={'flex-end'} flexWrap={'wrap'} py={2} gap={2} px={2} width={'100%'}>
            <Box
                display="flex"
                flexWrap="wrap"
                gap={0.5}
                sx={{
                    bgcolor: theme => theme.palette.mode === 'light' ? 'white' : theme.palette.background.paper,
                    p: 0.5, borderRadius: 5,
                    border: theme => `1px solid ${theme.palette.divider}`
                }}
            >
                {
                    data.slice(0, 4).map((value: any) => (
                        <Chip
                            label={`${value.display_text} ${value.value}`}
                            key={value.filter_code}
                            variant={selectedFilterCode === value.filter_code ? "filled" : "outlined"}
                            onClick={() => onSelectedFilter(value.filter_code)}
                            onDelete={selectedFilterCode === value.filter_code ? () => onSelectedFilter(null) : undefined}
                            color={selectedFilterCode === value.filter_code ? "primary" : "default"}
                            deleteIcon={<Cancel />}
                            clickable
                            sx={{
                                border: 0,
                                px: 0.25,
                                borderRadius: '16px',
                            }}
                        />
                    ))
                }
            </Box>
            <Box
                display="flex"
                flexWrap="wrap"
                gap={0.5}
                sx={{
                    bgcolor: theme => theme.palette.mode === 'light' ? 'white' : theme.palette.background.paper,
                    p: 0.5, borderRadius: 5,
                    border: theme => `1px solid ${theme.palette.divider}`
                }}
            >
                {
                    data.slice(4).map((value: any) => (
                        <Chip
                            label={`${value.display_text} ${value.value}`}
                            key={value.filter_code}
                            variant={selectedFilterCode === value.filter_code ? "filled" : "outlined"}
                            onClick={() => onSelectedFilter(value.filter_code)}
                            onDelete={selectedFilterCode === value.filter_code ? () => onSelectedFilter(null) : undefined}
                            color={selectedFilterCode === value.filter_code ? "primary" : "default"}
                            deleteIcon={<Cancel />}
                            clickable
                            sx={{
                                border: 0,
                                px: 0.25,
                                borderRadius: '16px',
                            }}
                        />
                    ))
                }
            </Box>
        </Box>
    );
};